import objectToFormData from "object-to-formdata";
import { Call, ApiUrl, PageParams, ParseGeneralResponse, optionalPageParams } from "./ApiUtils";
import AppConfig from "../config/AppConfig";

export function fetchOrganizations(page = 1, perPage = 10000, getAll = false) {
  perPage = perPage ? perPage : 10000
  const url = ApiUrl(
    `v2/organization?${optionalPageParams(page, perPage,false)}&get_all=${getAll}&operation_code=ORGI`
  );
  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: { organizations: "", pagination: "meta.pagination" },
    },
    false
  );
}

export function saveOrganization(isNew, data) {
  if (
    data.phone_number &&
    data.phone_number.length > 0 &&
    data.phone_number[0] !== "+"
  ) {
    data.phone_number = `+${data.phone_number}`;
  }
  const formData = objectToFormData(data);
  const url = isNew
    ? ApiUrl("v2/organization")
    : ApiUrl(`v2/organization/${data.id}`);
  const method = isNew ? "post" : "put";
  formData.append("operation_code", isNew ? "ORGC" : "ORGU");
  return Call(
    method,
    url,
    formData,
    ParseGeneralResponse,
    { responseDataKeys: { organization: "" } },
    false
  );
}

export function fetchOrganizationDetails(orgId) {
  const url = ApiUrl(`v2/organization/${orgId}?operation_code=ORGS`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { organization: "organization" },
  });
}

export function fetchUserOrgs(passOrg = true , user_id) {
  const url = ApiUrl(
    `v2/organization?user_id=${user_id}&operation_code=ORGI`
  );
  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: {
        organizations: "organizations",
        pagination: "meta.pagination",
      },
    },
    passOrg
  );
}

export function deleteOrganization(id) {
  const url = ApiUrl(`v2/organization/${id}?operation_code=ORGD`);
  return Call("delete", url, {}, ParseGeneralResponse);
}

export function getFetchOrganizations(page = 1, perPage = 10000, getAll = false, fleetLite = false) {
  let queryParams = optionalPageParams(page, perPage, false);
  if (getAll) {
    queryParams += "&get_all=true";
  }
  if (fleetLite) {
    queryParams += "&fleet_lite=true";
  }

  const url = ApiUrl(`v2/organization?${queryParams}&operation_code=ORGI`);

  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: { organizations: "", pagination: "meta.pagination" },
    },
    false
  );
}

export function setOrganizationSetting(data, orgId) {
  const { setting_name , setting_value } = data;
  const url = ApiUrl(`v2/organization/${orgId}/update_setting`);
  const formData = objectToFormData({ setting_name, setting_value, operation_code: "ORGSET" });
  return Call("put", url, formData, ParseGeneralResponse);
}

/**
 * Persist a single OrganizationConfig key/value via
 * `PUT /v2/organization/update_org_config`. Used by the v2 Items & Measure
 * redesign to PATCH the org-level `items_measure_default_mode` whenever the
 * user flips the section's mode toggle (fires immediately, not on order save).
 *
 * Returns the saved settings array on success or an errors payload on failure.
 */
export function updateOrgConfigSetting(orgId, settingName, settingValue) {
  const url = ApiUrl("v2/organization/update_org_config");
  return Call("put", url, {
    organization_id: orgId,
    setting_name: settingName,
    setting_value: settingValue,
  }, ParseGeneralResponse, {
    responseDataKeys: { settings: "org_config_settings" },
  });
}

export function setOrganizationConfig(data, orgId) {
  data.operation_code="ORGSET";
  const url = ApiUrl(`v2/organization/${orgId}/configuration`);
  return Call("post", url, data, ParseGeneralResponse, {
    responseDataKeys: { org_config: "" },
  });
}

export function fetchOrganizationConfigs(orgId , passOrg=true) {
  const url = ApiUrl(`v2/organization/${orgId}/configuration_details?operation_code=ORGCD`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { org_configurations: "org_configurations" },
  } , passOrg);
}

export function fetchOrgDeliveryZipcodes(orgId) {
  const url = ApiUrl(`v2/delivery_zip?org_id=${orgId}&operation_code=ORGDZ`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { dow_zipcodes: "dow_zip_codes" },
  });
}

export function fetchCreditLimitExceededAccounts(orgId,wh_location_id) {
  const url = ApiUrl(`v2/credit_limit/exceeded_accounts?organization_id=${orgId}&org_id=${orgId}&wh_location_id=${wh_location_id}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { accounts: "accounts" },
  });
}

export function saveConfiguration(data) { 
  const url = ApiUrl(`v2/organization/order_type_save_configuration`);
  return Call("put", url, data, ParseGeneralResponse, {
    responseDataKeys: { data: "" },
  });
}

export function fetchORgConfigs(id) {
  const settingName="order_types,ui_version,service_level_flow_enabled,items_measure_units_screen,print_label_based_on_lpn,lpn_label_template,items_measure_hidden_fields,enable_able"
  const url = ApiUrl(`v2/organization/get_configuration?org_id=${id}&setting_names=${settingName}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { data: "" },
  } );
}

export function fetchOrgActivityLogs(orgId, page = 1, perPage = 20,reference="ALL", usersList = "ALL", fromDate, toDate, searchText) {
  const url = ApiUrl(`v2/organization/organization_activities_list?organization_id=${orgId}&page=${page}&per_page=${perPage}&reference=${reference}&user_name=${usersList}&from_date=${fromDate}&to_date=${toDate}&description=${searchText}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { data: "", pagination: "meta.pagination" },
  });
}

export function prugeOrgData(data) {
  const url = ApiUrl(`v2/data_purge/purge_org_data`);
  return Call("delete", url, data, ParseGeneralResponse, {
    responseDataKeys: { message: "message", purgedRecord: "purged_records" },
  });
}

// Mapped agents (host<->agent) + per-agent agent_tender_mode (auto|manual|none).
export function fetchMappedAgents(orgId) {
  const url = ApiUrl(`v2/organization/mapped_agents?org_id=${orgId}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    // agent_order_creation_mode gates the per-agent Auto-tender toggle in the UI;
    // it must be whitelisted here or ParseGeneralResponse drops it.
    responseDataKeys: {
      agents: "agents",
      agent_order_creation_mode: "agent_order_creation_mode",
    },
  });
}

export function updateAgentTenderMode(orgId, agentId, agentTenderMode) {
  const url = ApiUrl(`v2/organization/update_agent_auto_create`);
  return Call(
    "post",
    url,
    { org_id: orgId, agent_id: agentId, agent_tender_mode: agentTenderMode },
    ParseGeneralResponse,
    { responseDataKeys: { success: "success", agentTenderMode: "agent_tender_mode" } }
  );
}